module.exports = __webpack_public_path__ + "img/errorblue.bd0535c4.svg";